module.exports = "<span \r\n    class=\"toaster\"\r\n    [ngClass]=\"toasterClass\"\r\n    [innerHtml]=\"message\">\r\n</span>\r\n"